<template>
<div class="chapter">
<div class="inner_page">
<div id="ack">
<br/><br/><br/><br/><br/><br/>
<p style="text-align: center;"><img alt=" " src="media/file2.png" style="width:3.96037in;height:2.72917in"/></p><br/>
<p style="text-align: center; font-weight:bold;">Bridget’s 1950s Hay</p><br/>
<p style="text-align: center;">my childhood world of streets, shops and places to play</p><br/>
<p style="text-align: center;"><img alt=" " src="media/file3.png" style="width:2.00028in;height:2.8754in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?618a091a